var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "bla ",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17,4V9H18A3,3 0 0,1 21,12V17H17V21H6V17H2V12A3,3 0 0,1 5,9H6V4H17M18,13A1,1 0 0,1 17,12A1,1 0 0,1 18,11A1,1 0 0,1 19,12A1,1 0 0,1 18,13M3,12V16H6V14H17V16H20V12A2,2 0 0,0 18,10H5A2,2 0 0,0 3,12M16,20V15H7V20H16M7,5V9H16V5H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.16e34324000a77229a37133ea883ad5d.svg";
export { ForwardRef as ReactComponent };